export default function (id) {
  let window = `relatorio.remocao.prevPagRebo`
  !this.$uloc.window.get(window) && this.$uloc.window.new({
    wid: window,
    title: 'Relatório de Previsão de Pagamento de Reboquistas',
    width: '600',
    height: '350',
    minHeight: '500px',
    backdrop: false,
    maximize: false,
    clickOutside: false,
    windowClass: 'erp-window',
    contentClass: 'overflow-hidden',
    props: {
      id: id
    }
  }, () => import('./RemocaoPrevPagRebo.vue'))
    .then((wid) => {
      console.log(wid)
    }) // return wid
}
